/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoMonthPicker {
    restrict = "E";
    scope = {
      name: "@",
      ngModel: "=ngModel",
      disabled: "=ngDisabled",
      change: "&ngChange",
      required: "=ngRequired",
      tabIndex: "=?",
      invalid: "=isInvalid"
    };

    require = "ngModel";

    templateUrl = "app/components/controls/monthPickerTemplate.html";

    link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
        scope.resolvedMonthText = this.$translate.instant("LABEL_MONTH");
        scope.getMonthNumbers = function(): number[] {
            return  new Array(1,2,3,4,5,6,7,8,9,10,11,12);
        }
    }

    constructor(private $translate: angular.translate.ITranslateService) {

    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($translate) => {
        return new MeevoMonthPicker($translate);
      };

      directive.$inject = ["$translate"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoMonthPicker", MeevoMonthPicker.factory());

}